import React, { useMemo } from 'react';
import { useTranslate } from 'react-translate-plus';
import styled from 'styled-components';

import { mediaQuery } from '../../app/setupResponsiveness';
import { LandingPageCard } from './LangingPageCard/LandingPageCard';
import { cardsData } from './cardsData';

const { workstations, templates, others } = cardsData;

export const LandingPageV2: React.FC = () => {
  /* lib hooks */
  const t = useTranslate('LandingPageV2');

  const data1 = useMemo(() => {
    return workstations.map((item) => ({
      ...item,
      actionText: t('CONFIGURE_WORKSTATION'),
      nameLocalisation: t(item.nameLocalisation),
      actionText2: t('NAME_SUFFIX'),
    }));
  }, [t]);

  const data2 = useMemo(() => {
    return templates.map((item) => ({
      ...item,
      actionText: t('CONFIGURE_WITH_TEMPLATE'),
    }));
  }, [t]);

  const data3 = useMemo(() => {
    return others.map((item) => ({
      ...item,
      actionText: t('CONFIGURE_FROM'),
      nameLocalisation: t(item.nameLocalisation),
    }));
  }, [t]);

  return (
    <Wrapper>
      <Styles>
        <LandingPageCard data={data1} />
        <LandingPageCard data={data2} />
        <LandingPageCard data={data3} />
      </Styles>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex: 1 1 0%;
  position: relative;
`;

const Styles = styled.div`
  bottom: 0;
  display: flex;
  flex-flow: column nowrap;
  left: 0;
  overflow-y: scroll;
  position: absolute;
  right: 0;
  top: 0;

  @media screen and (${mediaQuery.xlFrom}) {
    flex-flow: row nowrap;
  }
`;
